//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "SOFA",
  data() {
    return {
      disabled: false,
      hasScore: false,
      defaultJson: {
        "PaO2/FiO2Title": "PaO2/FiO2",
        "plateletTitle": "血小板计数",
        "bilTitle": "血清胆红素浓度",
        "CardiovascularTitle": "心血管功能",
        "GCSTitle": "Glasgow (GCS)昏迷评分",
        "creatinineTitle": "血清肌酐浓度",
        "urineTitle": "尿量",

        "PaO2/FiO2": "PaO2/FiO2[mmHg (kPa)]",
        "platelet": "血小板计数 (*10^9/L)",
        "bil": "血清胆红素浓度[mg/dl (umol/L)]",
        "Cardiovascular": "心血管功能",
        "GCS": "Glasgow (GCS)昏迷评分",
        "creatinine": "血清肌酐浓度[mg/dl (umol/L)]",
        "urine": "尿量 (ml/d)",
      },
      form: {
        pao2: "",
        platelet: "",
        bil: "",
        Cardiovascular: "",
        GCS: "",
        creatinine: "",
        urine: ""
      },
      pao2List: [
        { value: "0", name: "≥400 (53.3)", shortName: "≥400 (53.3)" },
        { value: "1", name: "<400 (53.3)", shortName: "<400 (53.3)" },
        { value: "2", name: "<300 (40.0)", shortName: "<300 (40.0)" },
        { value: "3", name: "<200 (26.7)", shortName: "<200 (26.7)" },
        { value: "4", name: "<100 (13.3)", shortName: "<100 (13.3)" },
      ],
      plateletList: [
        { value: "0", name: "≥150", shortName: "≥150" },
        { value: "1", name: "<150", shortName: "<150" },
        { value: "2", name: "<100", shortName: "<100" },
        { value: "3", name: "<50", shortName: "<50" },
        { value: "4", name: "<20", shortName: "<20" },
      ],
      bilList: [
        { value: "0", name: "<1.2 (20)", shortName: "<1.2 (20)" },
        { value: "1", name: "1.2~1.9 (20~32)", shortName: "1.2~1.9 (20~32)" },
        { value: "2", name: "2.0~5.9 (33~101)", shortName: "2.0~5.9 (33~101)" },
        { value: "3", name: "6.0~11.9 (102~204)", shortName: "6.0~11.9 (102~204)" },
        { value: "4", name: ">12.0 (204)", shortName: ">12.0 (204)" },
      ],
      CardiovascularList: [
        { value: "0", name: "MAP≥70mmHg", shortName: "MAP≥70mmHg" },
        { value: "1", name: "MAP≤70mmHg", shortName: "MAP≤70mmHg" },
        { value: "2", name: "多巴胺<5.0ug/kg/min或多巴胺酚丁胺(任意计量)", shortName: "多巴胺<5.0ug/kg/min或多巴胺酚丁胺(任意计量)" },
        { value: "3", name: "多巴胺5.0~15.00ug/kg/min或肾上腺素≤0.10ug/kg/min或去甲肾上腺素≤0.10ug/kg/min", shortName: "多巴胺5.0~15.00ug/kg/min或肾上腺素≤0.10ug/kg/min或去甲肾上腺素≤0.10ug/kg/min" },
        { value: "4", name: "多巴胺>15.00ug/kg/min或肾上腺素>0.10ug/kg/min或去甲肾上腺素>0.10ug/kg/min ", shortName: "多巴胺>15.00ug/kg/min或肾上腺素>0.10ug/kg/min或去甲肾上腺素>0.10ug/kg/min" },
      ],
      GCSList: [
        { value: "0", name: "15", shortName: "15" },
        { value: "1", name: "13~14", shortName: "13~14" },
        { value: "2", name: "10~12", shortName: "10~12" },
        { value: "3", name: "6~9", shortName: "6~9" },
        { value: "4", name: "<6", shortName: "<6" },
      ],
      creatinineList: [
        { value: "0", name: "<12 (110)", shortName: "<12 (110)" },
        { value: "1", name: "1.2~1.9 (110~170)", shortName: "1.2~1.9 (110~170)" },
        { value: "2", name: "2.0~3.4 (171~299)", shortName: "2.0~3.4 (171~299)" },
        { value: "3", name: "3.5~4.9 (300~440)", shortName: "3.5~4.9 (300~440)" },
        { value: "4", name: ">5.0 (440)", shortName: ">5.0 (440)" },
      ],
      urineList: [
        { value: "3", name: "<500", shortName: "<500" },
        { value: "4", name: "<200", shortName: "<200" },
      ],
      formulaInfo: {}
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result =
          form.pao2 +
          form.platelet +
          form.bil +
          form.Cardiovascular +
          form.GCS +
          form.creatinine +
          form.urine;
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/SOFA.vue